var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-title',{attrs:{"title":"Branch","subtitle":"List Data Branch"}}),_c('v-btn',{staticClass:"ma-3 white--text float-right",attrs:{"to":"/master/branch/create","small":"","elevation":"1","color":"primary"}},[_vm._v(" Create "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("mdi-plus-circle ")])],1),_c('supplier-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }